import _ from "lodash"

export default {

  namespaced : true,
  
  state : {
    client : null,
    broker : null,
  },

  mutations: {

    setClient(state, client) {
      state.client = client;
    },

    setBroker(state, broker) {
      state.broker = broker;
    },

    // this is when we mutate any of the applicants within the client
    // e.g. when we are re-ordering applicants in the applicant list
    // this method is called
    setApplicants(state, applicants) {
      state.client.applicants = applicants
    },

    // this is when we are updating the applicant's name and we want to 
    // ensure that changes are reflected in the applicant navigation
    setApplicantName(state, params) {
      for(let i=0; i < state.client.applicants.length; i++) {
        if(state.client.applicants[i].id == params.applicantId) {
          if(params.firstName != null) {
            state.client.applicants[i].person.first_name = params.firstName
          }

          if(params.lastName != null) {
            state.client.applicants[i].person.last_name = params.lastName 
          }
        }
      }
    },
  },
}